import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const InventoryManagement = {
  Helmet: lazy(() => import('./components/Helmet')),
  Layout: lazyNamed(() => import('./containers/Layout'), 'Layout'),
  Stock: lazyNamed(() => import('./containers/Stock'), 'StockTable'),
  Dispatch: {
    New: lazyNamed(() => import('./containers/Dispatches'), 'DispatchTable'),
    Layout: lazyNamed(() => import('./containers/Dispatches/Layout'), 'Layout'),
  },
  SendDispatch: {
    Form: lazyNamed(() => import('./containers/SendDispatch'), 'SendDispatch'),
    Layout: lazyNamed(() => import('./containers/SendDispatch/components/Layout'), 'Layout'),
  },
};
export default InventoryManagement;
